import { Provider } from "react-redux";
import { OpenFeatureProvider } from "@openfeature/react-sdk";
import { openFeatureClient } from "shared/utils/openFeature/openFeature.client";
import { DefaultTheme, ThemeProvider as StyledThemeProvider } from "styled-components";
import { theme, muiTheme } from "config/theme";
import { legacyLocales } from "config/localization";
import { ThemeProvider } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { NotificationProvider, BannerStateWrapper } from "shared/components";

import "./shared/utils/localization/i18next";

import { store } from "./legacy/configureStore";
import Application from "./legacy/containers/App";
import LanguageProvider from "./legacy/containers/LanguageProvider";
// TODO: remove when styles will be updated
import "sanitize.css/sanitize.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-notifications/lib/notifications.css";

const queryClient = new QueryClient();

function App() {
  return (
    <BannerStateWrapper>
      <OpenFeatureProvider client={openFeatureClient}>
        <Provider store={store}>
          <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools initialIsOpen={false} />
            <LanguageProvider messages={legacyLocales}>
              <ThemeProvider theme={muiTheme}>
                <StyledThemeProvider theme={theme as DefaultTheme}>
                  <NotificationProvider>
                    <Application />
                  </NotificationProvider>
                </StyledThemeProvider>
              </ThemeProvider>
            </LanguageProvider>
          </QueryClientProvider>
        </Provider>
      </OpenFeatureProvider>
    </BannerStateWrapper>
  );
}

export default App;
